import { t } from '@lingui/macro';
import { Department } from '~/app/views/Departments';
import useCachedQuery from '../useCachedQuery';
import { QueryOptions, QueryResult } from '../useQuery';

const getNoDepartmentOption = () => {
    const noDepartment: Department = {
        number: 0,
        name: t`No department`,
        access: true,
        isDepartment: true,
    };
    return noDepartment;
};

/**
 * Custom hook responsible to fetch departments
 */
export function useDepartments({
    hideBarred,
    omitDistributionKeys,
    includeNoDepartmentOption,
    options,
}: {
    hideBarred?: boolean;
    omitDistributionKeys?: boolean;
    includeNoDepartmentOption?: boolean;
    options?: QueryOptions;
}): QueryResult<Department[]> {
    const hideBarredQueryString = hideBarred !== undefined && hideBarred !== null ? `&barred=${!hideBarred}` : ``;
    const endpoint = `/departments?includeDistributionKeys=${!omitDistributionKeys}${hideBarredQueryString}`;
    const departmentsQuery = useCachedQuery<Department[]>(endpoint, [], options);

    return {
        ...departmentsQuery,
        data: [...(includeNoDepartmentOption ? [getNoDepartmentOption()] : []), ...departmentsQuery.data],
    };
}
